import Modal from '~/components/Modal';
import RadioOption from '~/components/RadioOption';
import { useBusinessInfo } from '~/lib/Queries';
import Loading from '~/components/Loading';
import { useEffect, useState } from 'react';
import InfoMessageBlock from '~/components/InfoMessageBlock';
import useBusinessPostApi from '~/lib/useBusinessPostApi';
import * as Toast from '~/lib/Toast';

const ClientSettingsModal = ({ isOpen, onClose }) => {
    const { data, isLoading, refetch } = useBusinessInfo();
    const [option, setOption] = useState('');
    const { save, isSaving } = useBusinessPostApi(`/clients/settings`);

    const currentOption = data?.clientDistinct || '';

    useEffect(() => {
        setOption(currentOption);
    }, [currentOption]);

    function doSave() {
        save({
            distinctBy: option,
        }).then(result => {
            refetch();
            onClose();
            Toast.success(
                'Successfully saved. Any changes to how clients are distinct will apply to new clients.',
            );
        });
    }

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => {
                onClose();
                setOption(currentOption);
            }}
        >
            <h2>Client Settings</h2>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <div className="panel-label mt-4">
                        Clients are Distinct By
                    </div>
                    <div className="panel p-4">
                        <RadioOption
                            checked={!option}
                            onChange={() => setOption('')}
                            label="Email Only"
                            description="Submissions will be applied to the same client as long as they have the same email"
                        />
                        <RadioOption
                            checked={option === 'name'}
                            onChange={() => setOption('name')}
                            label="Email and Name"
                            description="If a submission has the same name AND email address it will be applied to the same client, otherwise a new client will be created"
                        />
                    </div>
                    {option !== currentOption && (
                        <InfoMessageBlock className="mt-2">
                            Changing this will affect newly submitted forms and
                            future imports. Existing clients will not be
                            changed.
                        </InfoMessageBlock>
                    )}

                    <button
                        type="button"
                        className="mt-4 btn-save"
                        onClick={() => doSave()}
                    >
                        {isSaving ? 'Saving...' : 'Save'}
                    </button>
                </>
            )}
        </Modal>
    );
};

export default ClientSettingsModal;
